// 交易系统 https://wiki.tigerbrokers.net/pages/viewpage.action?pageId=5111968
export const HOST = ['https://api-test.ihuhoo.com', 'https://api.tradeup.com'];
export const API = {
    history: '/portfolio/deposit_history'
};
